import { Component, Input, OnInit } from '@angular/core';

import { AuthService } from '../../../core';
import { isTipoPessoaCentralCompras } from '../../pessoa/tipo';

@Component({
    selector: 'sgt-cliente-analise-mercado-header',
    templateUrl: './cliente-analise-mercado-header.component.html',
    styleUrls: ['./cliente-analise-mercado-header.component.less']
})
export class ClienteAnaliseMercadoHeaderComponent implements OnInit {
    isRepresentante: boolean;

    @Input() idCliente: number
    @Input() tipoPessoa: number;
    @Input() codigoIntegracaoErpCliente: string;
    @Input() cnpjCpfCliente: string;
    @Input() nomeCliente: string;
    @Input() nomeFantasiaCliente: string;
    @Input() nomeCidadeCliente: string;
    @Input() ufCliente: string;

    /** Se deve exibir o representante */
    @Input() showRepresentante = true;
    @Input() codigoIntegracaoErpRepresentante: string;
    @Input() nomeRepresentante: string;
    @Input() nomeFantasiaRepresentante: string;

    /** Se deve exibir o ano */
    @Input() showAno = true;
    @Input() ano: number;

    /** Se deve exibir os participantes quando for uma central de compras */
    @Input() showParticipantesCentralCompras = true;

    /** Se deve exibir a classificação de faturamento pretendida */
    // @Input() showClassificacaoFaturamentoPretendida = true;


    constructor(private authService: AuthService) { }

    ngOnInit() {
        this.isRepresentante = this.authService.isRepresentante();
    }

    /** Verifica se o cliente é uma central de compras */
    isCentralCompras(): boolean {
        return isTipoPessoaCentralCompras(this.tipoPessoa);
    }
}
